import axios from "axios"

const getAllEvents = () => {
  return new Promise((resolve, reject) => {
    axios.get(process.env.REACT_APP_BASE_URL + "/event")
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export default getAllEvents;
